<app-auth-layout [prefix]="prefix">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" class="d-block mb-4"></app-breadcrumbs>

  <ng-container form>
    @if ((errors$ | async)?.length) {
      @if (errors$ | async; as errors) {
        <app-alert
          class="d-block mb-4"
          [status]="'type--danger'"
          [title]="prefix + '-formulier-server-errors-titel' | fromDictionary"
          [prefix]="prefix"
          [showDefaultError]="true"
          [errors]="errors"
        ></app-alert>
      }
    }

    <form [formGroup]="group">
      <mat-form-field [appearance]="'fill'" [color]="'accent'" [class.has--label]="true" [class.is--custom-valid]="isValid()">
        <mat-label>{{ 'formulier-veld-label-email' | fromDictionary }}</mat-label>

        <input
          matInput
          formControlName="email"
          [placeholder]="'formulier-veld-placeholder-email' | fromDictionary"
          autocomplete="email"
          type="text"
          />

        @if (group.get('email')?.pending && formSubmitted) {
          <app-icon
            anchor="icon-loader"
            matSuffix
            class="icon-secondary anim--spinning"
          ></app-icon>
        }

        @if (group.get('email')?.valid && formSubmitted) {
          <div matSuffix class="d-inline-flex chip chip--success p-0">
            <app-icon anchor="icon-check"></app-icon>
          </div>
        }

        @if (group.get('email')?.errors?.['email'] === true) {
          <mat-error>
            <!--{{ field | formError : config.customValidationMessages }}-->
            {{ 'formulier-email-error-bericht' | fromDictionary }}
          </mat-error>
        }
        <!--<mat-error *ngIf="group.get('email')?.errors?.['required'] === true">
        Dit veld is verplicht
      </mat-error>-->
    </mat-form-field>

    <div [class.d-none]="!group.get('email')?.valid || !formSubmitted">
      <mat-form-field [appearance]="'fill'" [color]="'accent'" [class.has--label]="true" [class.is--custom-valid]="isValid()">
        <mat-label>{{ 'formulier-veld-label-wachtwoord' | fromDictionary }}</mat-label>

        <input
          matInput
          formControlName="password"
          [placeholder]="'formulier-veld-placeholder-wachtwoord' | fromDictionary"
          autocomplete="password"
          type="password"
          />

        @if (group.get('password')?.errors?.['required'] === true) {
          <mat-error>
            <!--{{ field | formError : config.customValidationMessages }}-->
            {{ 'formulier-veld-verplicht-bericht' | fromDictionary }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="text-center">
      @if (group.get('email')?.valid && formSubmitted) {
        <a
          [routerLink]="['/', 'auth', 'wachtwoord-vergeten']"
          [queryParams]="{ email: group.get('email')?.value || '' }"
          class="link fw-demi d-inline-block w-100 text-center mt-3 mb-4"
          >
          {{ prefix + '-wachtwoord-vergeten-knoptekst' | fromDictionary }}
        </a>
      }
      @if (!group.get('email')?.errors || !formSubmitted || group.get('email')?.valid) {
        <button
          (click)="handleSubmit(group.value)"
          class="button button--secondary mt-3 mb-3"
          type="submit"
          >
          {{ 'formulier-inloggen-knop-tekst' | fromDictionary }}
        </button>
      }
    </div>

    @if (isNewUser && formSubmitted) {
      <div class="alert alert--info p-lg-3">
        <p class="type-body-sm fw-normal">
          {{ 'inloggen-mislukt-account-onbekend-melding-tekst' | fromDictionary }}
        </p>
        <a
          [routerLink]="['/', 'auth', 'registreren']"
          [queryParamsHandling]="'merge'"
          [queryParams]="{ email: group.get('email')?.value }"
          class="button button--secondary button--sm"
          >
          {{ prefix + '-registreren-knop-tekst' | fromDictionary }}
        </a>
      </div>
    }

    @if (group.get('email')?.errors?.['user_blocked'] === true && formSubmitted) {
      <div class="alert alert--success p-md-4">
        <span>{{ 'inloggen-oud-account-herkend-subtitel' | fromDictionary }}</span>
        <h2 class="h4 mb-2">{{ 'inloggen-oud-account-herkend-titel' | fromDictionary }}</h2>
        <p>{{ 'inloggen-oud-account-herkend-tekst' | fromDictionary }}</p>
        @if ((inviteSent$ | async) !== true) {
          <button
            class="button button--success"
            (click)="sendActivationMail(group.get('email')?.value || '')"
            >
            @if (inviting$ | async) {
              <span class="icon-loader css-icon" title="laden"></span>
            }
            @if ((inviteSent$ | async) !== true) {
              <span>{{ 'inloggen-oud-account-herkend-knoptekst' | fromDictionary }}</span>
            }
          </button>
        }
        @if ((inviteSent$ | async) === true) {
          <span class="button button--success button-outline button--fake">
            <app-icon anchor="icon-check"></app-icon>
            <span>{{ 'inloggen-oud-account-herkend-email-verstuurd' | fromDictionary }}</span>
          </span>
        }
      </div>
    }
  </form>
</ng-container>
<ng-container footer>
  @if (group.get('email')?.valid && formSubmitted) {
    <div
      class="fs-body-sm mt-4 sign-in__footer__text"
      [innerHTML]="'inloggen-footer-tekst' | fromDictionary"
    ></div>
  }
  <!-- <a
  *ngIf="group.get('email')?.valid && formSubmitted"
  [routerLink]="['/', 'auth', 'wachtwoord-vergeten']"
  [queryParams]="{ email: group.get('email')?.value || '' }"
  class="link fw-demi d-inline-block w-100 text-center mt-3"
  >
  {{ prefix + '-wachtwoord-vergeten-knoptekst' | fromDictionary }}
</a> -->
</ng-container>
</app-auth-layout>
